import { set, get, cloneDeep, isEmpty, isNumber, isDate } from 'lodash';
import { User, Image, RateTypeCode, FormField } from '../../types';
import * as ROLES from '../constants/roles';

export default class Utilities {
    static getPhotoUrl(photos: Image[], size: string) {
        let photoArray = this.getPhotos(photos, size);
        if (photoArray.length > 0) {
            return photoArray[0].url;
        } else {
            return '';
        }
    }

    static getPhotos(photos: Image[], size: string) {
        if (photos && photos.length > 0) {
            const photos_by_size = photos.filter((photo) => photo.size === size);
            if (photos_by_size.length > 0) {
                return photos_by_size;
            } else {
                const large_photos = photos.filter((photo) => photo.size === 'large');
                if (large_photos.length > 0) {
                    return large_photos;
                } else {
                    return photos;
                }
            }
        } else {
            return [];
        }
    }
}

export const initField = (object: any, field: string, defaultValue: any) => {
    let curValue = get(object, field);
    if (object && (curValue === undefined || curValue === null)) {
        set(object, field, defaultValue);
    }
};

export const nullifyIds = (object: any, fields: string[]) => {
    let object_copy = cloneDeep(object);
    fields.forEach((field) => {
        if (get(object_copy, field) === '') {
            // set to null so that it is deleted from the db - cannot have set to null in react select
            set(object_copy, field, null);
        }
    });
    return object_copy;
};

export const checkFormValid = (object: any, formFields: FormField[]) => {
    let requiredFields = formFields.filter((f) => f.required === true);
    let valid = true;
    for (const field of requiredFields) {
        let curValue = get(object, field.name);
        if ((!isDate(curValue) && isEmpty(curValue) && !isNumber(curValue)) || !(object && curValue && curValue.toString().length > 0)) {
            valid = false;
            break;
        }
    }
    return valid;
};

export const userHasRole = (user: Partial<User>, roles: string[] = []) => {
    return user && user.roles && roles.some((role) => user.roles?.includes(role));
};

export const canEditFreightForwarder = (user: Partial<User>) => {
    return userHasRole(user, [ROLES.ADMIN, ROLES.SUPER, ROLES.EDIT]);
};
export const canViewFreightForwarder = (user: Partial<User>) => {
    return userHasRole(user, [ROLES.ADMIN, ROLES.SUPER, ROLES.EDIT, ROLES.VIEW]);
};
export const canDoSuperUserTasks = (user: Partial<User>) => {
    return userHasRole(user, [ROLES.ADMIN, ROLES.SUPER]);
};
export const isAdmin = (user: Partial<User>) => {
    return userHasRole(user, [ROLES.ADMIN]);
};

export const createDefaultStandAloneService = (activeRateTypeCode: RateTypeCode) => ({
    name: '',
    frequency: '',
    shipping_line: '',
    transit_time_days: 7,
    ratesType: activeRateTypeCode,
    origin: {
        port: {},
        country: {},
    },
    destination: {
        port: {},
        country: {},
    },
    overallCharge: {
        currency_id: '',
        buyMinimum: 0,
        sellMinimum: 0,
        deleted: false,
    },
});
